/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:26/03/2022
 @Time:15:27
 **/
export default class CalculUtil{

    /**
     * Method qui permet de recalculer le prix TTC aprés un changement de taxe
     * @param {number}oldPriceTTC
     * @param {number}oldTaxe
     * @param {number}newTaxe
     * @return {number}
     */
    static calculateNewPriceTTC(oldPriceTTC,oldTaxe,newTaxe)
    {
        return CalculUtil.prixTTC(CalculUtil.prixHTTC(oldPriceTTC,oldTaxe),newTaxe);//nouveau prix TTC
    }

    /**
     *retourne le prix tous taxe compris a partir d'un prix hors taxe et un taxe
     * @param prixHTC
     * @param taxe
     */
    static prixTTC(prixHTC,taxe)
    {
        return prixHTC+((prixHTC*taxe)/100);
    }

    /**
     * retourne le prix hors taxe a partir d'un prix TTC et un taxe
     * @param prixTTC
     * @param taxe
     * @return {number}
     */
    static prixHTTC(prixTTC,taxe)
    {
        return prixTTC/((taxe/100)+1);
    }



}